module.exports = __webpack_public_path__ + "img/424.74910904.png";